export interface Testimonial {
  /** i18n key used to look up name & quote in locale files */
  i18nKey: string;
  role: string;
  company: string;
  image: string;
  imagePosition?: string;
}

export const testimonials: Testimonial[] = [
  {
    i18nKey: "nikos",
    role: "Bar Manager",
    company: "Teddy's",
    image: "/testimonial_1.png",
  },
  {
    i18nKey: "nikolaos",
    role: "Owner",
    company: "Kudu Coffee",
    image: "/testimonial_2.png",
  },
  {
    i18nKey: "ilias",
    role: "Owner",
    company: "Koutsi Katsika",
    image: "/testimonial_3.png",
    imagePosition: "center 30%",
  },
];
